import * as Immutable from "immutable";
import { Decoration } from "./decoration";

export class HeaderDecoration extends Decoration {

  protected readonly MINOR_HEADER = "minorHeader";

  get minorHeader(): boolean { return this.getInternalValue<boolean>(this.MINOR_HEADER); }
  setMinorHeader(minorHeader: boolean): this { return this.setInternalValue(this.MINOR_HEADER, minorHeader); }
}